export default __webpack_public_path__ + "6a5a94426c21dab7c16ef1e137d6ae0e.png";